import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createRoom,
  createSection,
  createTouch,
  createUserApiCall,
  deleteUserApiCall,
  fetchProjectById,
  fetchProjectReportAction,
  fetchProjects,
  fetchRoomsByProject,
  fetchSectionsByProject,
  fetchTouchByTouchId,
  fetchTouchesByProject,
  fetchUserInfo,
  getAllProjectsApiCall,
  getUserApiCall,
  getUsersApiCall,
  loginApiCall,
  saveTouch,
  updateProjectAction,
} from "../actions/projectAction";

const initialState = {
  projects: [],
  pageInfo: null,
  isLoading: [],
  error: "",
  sections: [],
  rooms: [],
  touches: [],
  touchDeesign: null,
  user: null,
  users: [],
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { loading, code } = action.payload;

      if (loading) {
        state.isLoading = [...state.isLoading, code];
      }

      if (!loading) {
        let filterArray = state.isLoading.filter((item) => item != code);
        state.isLoading = filterArray;
      }
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setProjects: (state, action) => {
      state.projects = action.payload?.doc;
      state.pageInfo = action.payload?.pageinfo;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectionsByProject.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchSectionsByProject",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(fetchSectionsByProject.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchSectionsByProject",
            loading: false,
          },
        });
        state.sections = action.payload;
      })
      .addCase(fetchSectionsByProject.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchSectionsByProject",
            loading: false,
          },
        });
        state.error = action.payload;
      });

    builder
      .addCase(fetchRoomsByProject.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchRoomsByProject",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(fetchRoomsByProject.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchRoomsByProject",
            loading: false,
          },
        });
        state.rooms = action.payload;
      })
      .addCase(fetchRoomsByProject.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchRoomsByProject",
            loading: false,
          },
        });
        state.error = action.payload;
      });

    builder
      .addCase(fetchTouchesByProject.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchTouchesByProject",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(fetchTouchesByProject.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchTouchesByProject",
            loading: false,
          },
        });
        state.touches = action.payload;
      })
      .addCase(fetchTouchesByProject.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchTouchesByProject",
            loading: false,
          },
        });
        state.error = action.payload;
      });

    builder
      .addCase(createSection.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createSection",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(createSection.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createSection",
            loading: false,
          },
        });
      })
      .addCase(createSection.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createSection",
            loading: false,
          },
        });
      });

    builder
      .addCase(createRoom.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createRoom",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(createRoom.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createRoom",
            loading: false,
          },
        });
      })
      .addCase(createRoom.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createRoom",
            loading: false,
          },
        });
      });

    builder
      .addCase(createTouch.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createTouch",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(createTouch.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createTouch",
            loading: false,
          },
        });
      })
      .addCase(createTouch.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createTouch",
            loading: false,
          },
        });
      });

    builder
      .addCase(fetchTouchByTouchId.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchTouchByTouchId",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(fetchTouchByTouchId.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchTouchByTouchId",
            loading: false,
          },
        });
        state.touchDeesign = action.payload;
      })
      .addCase(fetchTouchByTouchId.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchTouchByTouchId",
            loading: false,
          },
        });
      });

    builder
      .addCase(saveTouch.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "saveTouch",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(saveTouch.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "saveTouch",
            loading: false,
          },
        });
      })
      .addCase(saveTouch.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "saveTouch",
            loading: false,
          },
        });
      });

    builder
      .addCase(loginApiCall.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "loginApiCall",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(loginApiCall.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "loginApiCall",
            loading: false,
          },
        });

        if (action?.payload) {
          toast.error(action?.payload);
        }
      });

    builder
      .addCase(createUserApiCall.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createUserApiCall",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(createUserApiCall.fulfilled, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createUserApiCall",
            loading: false,
          },
        });
        state.error = null;
      })

      .addCase(createUserApiCall.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "createUserApiCall",
            loading: false,
          },
        });

        if (action?.payload) {
          toast.error(action?.payload);
        }
      });

    builder
      .addCase(deleteUserApiCall.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "deleteUserApiCall",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(deleteUserApiCall.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "deleteUserApiCall",
            loading: false,
          },
        });

        if (action?.payload) {
          toast.error(action?.payload);
        }
      });

    builder
      .addCase(getUsersApiCall.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getUsersApiCall",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(getUsersApiCall.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getUsersApiCall",
            loading: false,
          },
        });
        state.users = action.payload;
      })
      .addCase(getUsersApiCall.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getUsersApiCall",
            loading: false,
          },
        });

        if (action?.payload) {
          toast.error(action?.payload);
        }
      });

    builder
      .addCase(fetchUserInfo.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchUserInfo",
            loading: true,
          },
        });
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchUserInfo",
            loading: false,
          },
        });
        state.error = null;
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchUserInfo",
            loading: false,
          },
        });

        if (action?.payload) {
          toast.error(action?.payload);
        }
      });

    builder
      .addCase(fetchProjectById.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchProjectById",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchProjectById",
            loading: false,
          },
        });

        if (action?.payload) {
          toast.error(action?.payload);
        }
      })
      .addCase(fetchProjectById.fulfilled, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchProjectById",
            loading: false,
          },
        });
        state.error = null;
      });

    builder
      .addCase(getUserApiCall.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getUserApiCall",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(getUserApiCall.fulfilled, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getUserApiCall",
            loading: false,
          },
        });

        state.error = null;
      })
      .addCase(getUserApiCall.rejected, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getUserApiCall",
            loading: false,
          },
        });

        state.error = null;
      });
    builder
      .addCase(getAllProjectsApiCall.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getAllProjectsApiCall",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(getAllProjectsApiCall.fulfilled, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getAllProjectsApiCall",
            loading: false,
          },
        });

        state.error = null;
      })
      .addCase(getAllProjectsApiCall.rejected, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "getAllProjectsApiCall",
            loading: false,
          },
        });

        state.error = null;
      });
    builder
      .addCase(updateProjectAction.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "updateProjectAction",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(updateProjectAction.fulfilled, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "updateProjectAction",
            loading: false,
          },
        });

        state.error = null;
      })
      .addCase(updateProjectAction.rejected, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "updateProjectAction",
            loading: false,
          },
        });

        state.error = null;
      });
    builder
      .addCase(fetchProjectReportAction.pending, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchProjectReportAction",
            loading: true,
          },
        });
        state.error = null;
      })
      .addCase(fetchProjectReportAction.fulfilled, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchProjectReportAction",
            loading: false,
          },
        });

        state.error = null;
      })
      .addCase(fetchProjectReportAction.rejected, (state) => {
        projectSlice?.caseReducers.setLoading(state, {
          payload: {
            code: "fetchProjectReportAction",
            loading: false,
          },
        });

        state.error = null;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setLoading, setProjects, setUser } = projectSlice.actions;

export default projectSlice.reducer;
